import React from 'react'
import PropTypes from 'prop-types'
import Header from './Header'
import DaySelectorBanner from './DaySelectorBanner'
import CallList from './CallList'
import './styles.css'

require('react-datepicker/dist/react-datepicker.css')

const CallLogPage = ({
  callDataByDate,
  selectCallLogFilter,
  date,
  dateArr,
  dateFormatted,
  handleCallLogClick,
  handleDateChange,
  handleDateSelectorClick,
  handleLeftArrowClick,
  handleRightArrowClick,
  isFetching,
  resetToToday,
  callLogFilter,
}) => (
  <div className="callLog">
    <Header
      date={date}
      resetToToday={resetToToday}
      handleChange={handleDateChange}
      handleFilterSelect={selectCallLogFilter}
      callLogFilter={callLogFilter}
    />
    <DaySelectorBanner
      dateFormatted={dateFormatted}
      dateArr={dateArr}
      handleDateSelectorClick={handleDateSelectorClick}
      handleLeftArrowClick={handleLeftArrowClick}
      handleRightArrowClick={handleRightArrowClick}
    />
    <CallList
      dateFormatted={dateFormatted}
      callDataByDate={callDataByDate}
      handleCallLogClick={handleCallLogClick}
      callLogFilter={callLogFilter}
      loading={isFetching}
    />
  </div>
)

CallLogPage.propTypes = {
  callDataByDate: PropTypes.object.isRequired,
  selectCallLogFilter: PropTypes.func.isRequired,
  date: PropTypes.object.isRequired,
  dateArr: PropTypes.array.isRequired,
  dateFormatted: PropTypes.string.isRequired,
  handleCallLogClick: PropTypes.func.isRequired,
  handleDateChange: PropTypes.func.isRequired,
  handleDateSelectorClick: PropTypes.func.isRequired,
  handleLeftArrowClick: PropTypes.func.isRequired,
  handleRightArrowClick: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  resetToToday: PropTypes.func.isRequired,
  callLogFilter: PropTypes.string.isRequired,
}

export default CallLogPage



// WEBPACK FOOTER //
// ./src/components/CallLog/CallLogPage/index.js